export default "__VITE_ASSET__MZMO2dqS__"